export const shipmentsReducer = (state = {}, action) => {
    switch (action.type) {
        case 'GET_SHIPMENT_REQUEST':
            return {
                ...state,
                isLoading: true,
                counts: {}
            };
        case 'GET_SHIPMENT_RESPONSE':
            return {
                ...state,
                list: action.payload.list,
                shipmentsTab: action.payload.shipmentsTab,
                shipmentsPageIndex: action.payload.shipmentsPageIndex,
                showingMax: action.payload.showingMax,
                isLoading: false,
                searchText: action.payload.searchText,
                counts: action.payload.counts
            };
        case 'SET_SELECTED_SHIPMENT':
            return {
                ...state,
                selectedAmount: action.payload.amount,
                selectedInvoices: action.payload.numbers
            };
        case 'OPEN_INVOICE_MODAL':
            return {
                ...state,
                invoiceUrl: action.payload
            };
        case 'OPEN_DOCUMENTS_MODAL_REQUEST':
            return {
                ...state,
                loadingDocuments: true
            };
        case 'OPEN_DOCUMENTS_MODAL_RESPONSE':
            return {
                ...state,
                documents: action.payload.documents,
                orderNumber: action.payload.orderNumber,
                loadingDocuments: false
            };
        case 'CLOSE_MODAL':
            return {
                ...state,
                documents: null,
                invoiceUrl: null
            };
        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/reducers/ShipmentReducer.js